import { render, staticRenderFns } from "./ViewerZoomDesign.vue?vue&type=template&id=27ef0f66&scoped=true"
import script from "./ViewerZoomDesign.vue?vue&type=script&lang=js"
export * from "./ViewerZoomDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerZoomDesign.vue?vue&type=style&index=0&id=27ef0f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef0f66",
  null
  
)

export default component.exports